import styled from "styled-components";

export const BookedForFormStyles = styled.div`
  width: 720px;
  max-width: 100%;
  background: ${({ theme }) => theme.colors.semantic.container.white};
  box-shadow: ${({ theme }) => theme.shadows.card};
  border-radius: ${({ theme }) => theme.radius[16]};
  overflow: hidden;

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${({ theme }) => theme.spacing[20]};
    border-bottom: 1px solid
      ${({ theme }) => theme.colors.semantic.separator};
  }

  .headerTitle {
    margin: 0;
  }

  .formBody {
    display: flex;
    flex-direction: column;
    padding: ${({ theme }) => theme.spacing[20]};
    gap: ${({ theme }) => theme.spacing[20]};
  }

  .weekSection,
  .slotSection {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[8]};
  }

  .footer {
    padding: ${({ theme }) => theme.spacing[16]}
      ${({ theme }) => theme.spacing[20]};
    border-top: 1px solid ${({ theme }) => theme.colors.semantic.separator};
    display: flex;
    justify-content: flex-end;
  }

  .saveButton {
    min-width: 180px;
  }
`;
